import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import AppShell from './app/AppShell';
import RequireSession from './auth/RequireSession';
import HealthPage from './pages/HealthPage';
import HistoryPage from './pages/HistoryPage';
import LobbiesPage from './pages/LobbiesPage';
import PlayersPage from './pages/PlayersPage';
import PoolPage from './pages/PoolPage';
import SettingsPage from './pages/SettingsPage';
import TeamsPage from './pages/TeamsPage';
import ProTeamsPage from './pages/ProTeamsPage';
import { ConfigProvider } from './store/config';
import { ToastProvider } from './ui/toast';
import './styles.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Polling intervals live in src/queries; these govern everything else.
      staleTime: 2_000,
      retry: 1,
      refetchOnWindowFocus: true,
    },
  },
});

const router = createBrowserRouter([
  {
    path: '/',
    element: <AppShell />,
    children: [
      { index: true, element: <LobbiesPage /> },
      { path: 'players', element: <PlayersPage /> },
      { path: 'teams', element: <TeamsPage /> },
      { path: 'dota-teams', element: <ProTeamsPage /> },
      { path: 'history', element: <HistoryPage /> },
      { path: 'pool', element: <PoolPage /> },
      { path: 'health', element: <HealthPage /> },
      { path: 'settings', element: <SettingsPage /> },
    ],
  },
]);

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ConfigProvider>
        <ToastProvider>
          <RequireSession>
            <RouterProvider router={router} />
          </RequireSession>
        </ToastProvider>
      </ConfigProvider>
    </QueryClientProvider>
  </StrictMode>,
);
